const get = (key, fallback = undefined) => process.env[key] ?? fallback

export const env = {
  // Runtime
  ENV: get('REACT_APP_ENV', 'production'),

  // API + web
  API_BASE_URL: get('REACT_APP_API_BASE_URL'),
  WEBSITE_URL: get('REACT_APP_WEBSITE_URL'),

  // Payments
  STRIPE_KEY: get('REACT_APP_STRIPE_KEY'),

  // Encryption secrets (client-side, non-sensitive obfuscation only)
  LOCAL_STORAGE_SECRET: get('REACT_APP_LOCAL_STORAGE_SECRET'),
  USER_LOG_SECRET: get('REACT_APP_USER_LOG_SECRET'),

  // Firebase (push notifications)
  FIREBASE: {
    API_KEY: get('REACT_APP_FIREBASE_API_KEY'),
    AUTH_DOMAIN: get('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    PROJECT_ID: get('REACT_APP_FIREBASE_PROJECT_ID'),
    STORAGE_BUCKET: get('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    MESSAGING_SENDER_ID: get('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    APP_ID: get('REACT_APP_FIREBASE_APP_ID'),
    MEASUREMENT_ID: get('REACT_APP_FIREBASE_MEASUREMENT_ID'),
  },
}

export const isProduction = env.ENV === 'production'
export const isDevelopment = env.ENV === 'development'

export default env
